import { render, staticRenderFns } from "./ImportLogDetails.vue?vue&type=template&id=2ff613bc&scoped=true&"
import script from "./ImportLogDetails.vue?vue&type=script&lang=js&"
export * from "./ImportLogDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff613bc",
  null
  
)

export default component.exports